module.exports = __webpack_public_path__ + "media/images/past_order_history/btn_Calendar_3_01-dc22763e79909f835d7bc0e18fc4c5d4.png";